import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { BootstrapPage } from './BootstrapPage';

interface BootstrapResetPasswordPageProps {
  location: Location;
}

const BootstrapResetPasswordPage: React.SFC<BootstrapResetPasswordPageProps> = ({ location }) => {
  return <BootstrapPage flow={FlowType.resetPassword} location={location} />;
};

export { BootstrapResetPasswordPage };
